"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var TabRouter_exports = {};
__export(TabRouter_exports, {
  ExpoTabRouter: () => ExpoTabRouter
});
module.exports = __toCommonJS(TabRouter_exports);
var import_native = require("@react-navigation/native");
function ExpoTabRouter(options) {
  var rnTabRouter = (0, import_native.TabRouter)(options);
  var router = {
    ...rnTabRouter,
    getStateForAction(state, action, options2) {
      if (action.type === "REPLACE") {
        var _ref;
        var payload = action.payload;
        return router.getStateForAction(state, {
          type: "JUMP_TO",
          source: action.source,
          target: action.target,
          payload: {
            name: (_ref = payload === null || payload === void 0 ? void 0 : payload.name) !== null && _ref !== void 0 ? _ref : "",
            params: payload === null || payload === void 0 ? void 0 : payload.params
          }
        }, options2);
      }
      if (action.type !== "JUMP_TO") {
        return rnTabRouter.getStateForAction(state, action, options2);
      }
      var route = state.routes.find(function(route2) {
        return route2.name === action.payload.name;
      });
      if (!route) {
        return null;
      }
      var shouldReset = !state.history.some(function(item) {
        return item.key === (route === null || route === void 0 ? void 0 : route.key);
      }) && !route.state;
      if (!shouldReset && "resetOnFocus" in action.payload && action.payload.resetOnFocus) {
        shouldReset = state.routes[state.index].key !== route.key;
      }
      if (shouldReset) {
        options2.routeParamList[route.name] = {
          ...options2.routeParamList[route.name]
        };
        state = {
          ...state,
          routes: state.routes.map(function(r) {
            if (r.key !== route.key) {
              return r;
            }
            return {
              ...r,
              state: void 0
            };
          })
        };
        return rnTabRouter.getStateForAction(state, action, options2);
      } else {
        return rnTabRouter.getStateForRouteFocus(state, route.key);
      }
    }
  };
  return router;
}
//# sourceMappingURL=TabRouter.js.map
